import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { fromJS } from 'immutable';
import { withStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';

import { injectIntl } from 'react-intl';
import messages from './messagesTravelCards';
import TravelCardsView from './TravelCardsView';
import inlineStyles from './styles';

const TravelCardsDialog = ({
    open,
    classes,
    faresSelected,
    travelCards,
    passengerNumber,
    intl: { formatMessage },
    selectedTravelCards,
    onChangeTravelCards,
    onDiscardTravelCards,
}) => {
    const [selectedTravelCardsState, setSelectedTravelCardsState] = React.useState(selectedTravelCards);

    useEffect(() => {
        setSelectedTravelCardsState(selectedTravelCards);
    }, [selectedTravelCards]);

    const handleCheckTravelCard = (travelCard, isChecked, linkedTravelSegment) => {
        const cleanedSelectionList = selectedTravelCardsState
            .filter((selectedTravelCard) => selectedTravelCard.getIn(['linkedTravelSegments', 0]) !== linkedTravelSegment);
        const updatedSelectedTravelCards = isChecked ? cleanedSelectionList.push(fromJS(travelCard)) : cleanedSelectionList;
        setSelectedTravelCardsState(updatedSelectedTravelCards);
    };

    const handleDiscard = () => {
        setSelectedTravelCardsState(selectedTravelCards);
        onDiscardTravelCards();
    };

    const handleSave = () => {
        onChangeTravelCards(selectedTravelCardsState);
    };

    const actions = (
        <div className="row" style={inlineStyles.dialogActionsRoot}>
            <div className="col-4 offset-3 offset-md-4">
                <Button
                    variant="contained"
                    id="srtTravelCardDiscardChanges"
                    onClick={handleDiscard}
                    fullWidth
                >
                    {formatMessage(messages.btnDiscardChanges)}
                </Button>
            </div>
            <div className="col-5 col-md-4">
                <Button
                    variant="contained"
                    id="srtSaveTravelCard"
                    onClick={handleSave}
                    color="primary"
                    fullWidth
                >
                    {formatMessage(messages.btnSaveTravelCard)}
                </Button>
            </div>
        </div>
    );

    return (
        <Dialog
            open={open}
            classes={{ paper: classes.dialogPaper }}
            onClose={handleDiscard}
            disableEnforceFocus
            maxWidth={false}
        >
            <DialogTitle classes={{ root: classes.dialogTitle }}>
                {formatMessage(messages.lblTitle)}
            </DialogTitle>
            <DialogContent classes={{ root: classes.dialogContent }}>
                <TravelCardsView
                    onCheckTravelCard={handleCheckTravelCard}
                    faresSelected={faresSelected}
                    travelCards={travelCards}
                    selectedTravelCards={selectedTravelCardsState}
                    passengerNumber={passengerNumber}
                />
            </DialogContent>
            <DialogActions>
                {actions}
            </DialogActions>
        </Dialog>
    );
};

TravelCardsDialog.propTypes = {
    intl: PropTypes.object,
    open: PropTypes.bool.isRequired,
    faresSelected: PropTypes.object.isRequired,
    travelCards: PropTypes.array.isRequired,
    onDiscardTravelCards: PropTypes.func.isRequired,
    onChangeTravelCards: PropTypes.func.isRequired,
    selectedTravelCards: PropTypes.object,
    passengerNumber: PropTypes.number,
    classes: PropTypes.object.isRequired,
};

TravelCardsDialog.defaultProps = {
    selectedTravelCards: fromJS([]),
};

export { TravelCardsDialog as TravelCardsDialogAlias };
export default injectIntl(withStyles(inlineStyles)(TravelCardsDialog));
